import React, { useRef } from "react";
import { Heading } from "../../../../../lib/components";

export default function SamplePage() {
	const sampleText = useRef(Math.random().toString(36).substring(7));

	return <Heading variant="heading1">{sampleText.current}</Heading>;
}
